import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { LayoutComponent } from './layout.component';
import { LoaderStripeModule } from './loader-stripe/loader-stripe.module';
import { LayoutService } from './_service/layout.service';
import * as fromLayout from './_store/layout.reducer';
import { AcceptancesModalComponent } from './acceptances-modal/acceptances-modal.component';
import { LoadersComponent } from './loaders/loaders.component';
import { HeaderMinimalComponent } from './header-minimal/header-minimal.component';
import { HeaderComponent } from './header/header.component';
import { InfoBarComponent } from './info-bar/info-bar/info-bar.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs/breadcrumbs.component';
import { GhostButtonComponent } from '../shared/components/ghost-button/ghost-button.component';
import { FormCheckboxComponent } from '../shared/components/forms/form-checkbox/form-checkbox.component';
import { AcceptancesChecboxesComponent } from '../shared/components/acceptances-checboxes/acceptances-checboxes.component';

@NgModule({
  declarations: [LayoutComponent, AcceptancesModalComponent],
  exports: [LayoutComponent, AcceptancesModalComponent],
  imports: [
    CommonModule,
    InfoBarComponent,
    FooterComponent,
    StoreModule.forFeature(fromLayout.featureName, fromLayout.layoutReducer),
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    LoaderStripeModule,
    LoadersComponent,
    HeaderMinimalComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    GhostButtonComponent,
    FormCheckboxComponent,
    AcceptancesChecboxesComponent
  ],
  providers: [LayoutService]
})
export class LayoutModule { }
